<template>
    <div>
        <v-menu
        v-model="show"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date.display"
            :label="label"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date.value"
          @input="show = false"
        ></v-date-picker>
      </v-menu>
    </div>
</template>

<script>
  import moment from 'moment';
    export default {
        name: 'DatePicker',
        props: ['label'],
        watch: {
          "date.value" (val) {
              this.date.display = moment(val).format("DD-MM-yyyy");
              this.$emit("setDate", val);
          }
        },
        data: () => ({
          show: false,
          date: {value: '', display: ''}
        }),
        methods: {
          setDate(val) {
              this.date.value = val;
              this.date.display = moment(val).format("DD-MM-yyyy");
          }
        }
    }
</script>